export default __webpack_public_path__ + "static/O0145-3ce5965a5a3c4556f7277f95323ed89f.png";